import type { AxiosResponse } from 'axios'
import { editResponse, showLoading, addPending, axiosRetry, removePending } from '@/utils/http/helper'
import store from '@/store'
import { getSessionItem } from '@/utils/sessionstorage'
import { getLocalItem } from '@/utils/localStorage'
import { retrieveLoginInfo } from '@/utils/menu'

// http request 拦截器
axios.interceptors.request.use(
  (config: any) => {
    // 展示loading
    showLoading(config)
    // 增加取消函数
    removePending(config)
    config._repeatRequestCancel && addPending(config)

    // 判断当前登录账户属于同一浏览器的最后一个登录者
    if (getSessionItem('zl-login-date') && getSessionItem('zl-login-date') !== getLocalItem('zl-login-date')) {
      retrieveLoginInfo()
      removePending(config)
    }
    const userInfo = store.getters['moduleCommon/getUserInfo']
    const params: any = {}
    if (config?.params && config.data == null) {
      Object.keys(config.params).forEach((key) => {
        if (config.params[key] !== null && config.params[key] !== undefined && config.params[key] !== '') {
          params[key] = config.params[key]
        }
      })
    }
    if (config.data == null) {
      config.params = { adminId: userInfo?.id, ...params }
    }

    return config
  },
  (error: any) => {
    // 失败进入
    return Promise.reject(error)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    removePending(response.config)
    editResponse(response)
    return response.data
  },
  (error: any) => {
    return axiosRetry(error)
  }
)
